<template>
  <div>
    <app-header :sysco="sysco"></app-header>
    <div class="container-fluid">
      <h1 class="display-4"><strong>{{caption("addproj_CreateProject")}}</strong></h1>
      <hr>
      <form @submit.prevent="projectcreate">
        <div class="form-row">
          <div class="form-group col-md-4">
            <label class="label">{{caption("addproj_CustomerName")}}</label>
            <input type="text" v-autofocus class="input form-control" @input="$v.form.custName.$touch()" v-model.trim="form.custName" />
            <div v-if="$v.form.custName.$dirty">
              <div class="text-danger" v-if="!$v.form.custName.required">{{caption("addwin_Required")}}</div>
            </div>
          </div>
          <div class="form-group col-md-4">
            <label class="label">{{caption("addproj_ProjectName")}}</label>
            <input type="text" class="input form-control" @input="$v.form.projName.$touch()" v-model.trim="form.projName" />
            <div v-if="$v.form.projName.$dirty">
              <div class="text-danger" v-if="!$v.form.projName.required">{{caption("addwin_Required")}}</div>
            </div>
          </div>
        </div>
        <button class="btn btn-primary mb-3" type="submit">{{caption("Submit")}}</button>
        <button class="btn btn-secondary mb-3" @click="cancel">{{caption("Cancel")}}</button>
      </form>
    </div>
  </div>
</template>

<script>
import AppHeader from "../intro/AppHeader";
import store from "../../ClientApp/store";
import { required } from "vuelidate/lib/validators";

export default {
  validations: {
    form: {
      custName: {
        required
      },
      projName: {
        required
      }
    }
  },
  data: function () {
    return {
      form: {
        custName: "",
        projName: ""
      },
      error: null
    };
  },
  computed: {
    sysco(){
      return this.$store.getters.getAuth.systemCompany;
    }
  },
  components: {
    AppHeader
  },
  methods: {
    projectcreate() {
      this.$v.form.$touch();
      if (this.$v.form.$error) return;

      const payload = {
        CustomerName: this.form.custName,
        ProjectName: this.form.projName
      };

      this.$store
        .dispatch("projectcreate", payload)
        .then(response => {
          this.$router.push("/projects/0");
        })
        .catch(error => {
          if (typeof error.data === "string" || error.data instanceof String) {
            this.errors = {
              error: [error.data]
            };
          } else {
            this.errors = error.data;
          }
        });
    },
    cancel(){
      this.$router.push("/projects/0");
    },
    caption(term){
      var cpt = this.$store.getters.getTranslationByTerm(term);
      return cpt.caption;
    }
  }
};
</script>

<style scoped>
@media (min-width: 600px) {
  .container-fluid {
    width: 75%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/projects/ProjectCreate.vue